import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { AppBadge } from "Components/AppBadge";

export const SubscribersDesc = styled("p")({
  color: colors.gray500,
  fontSize: 12,
  lineHeight: "16px",
  letterSpacing: 0.4,
  fontWeight: 400,
  fontFamily: "Manrope",
  marginTop: 4,
});

export const AppBadgeStyle = styled(AppBadge)({
  paddingLeft: "8px",
  paddingRight: "8px",
  paddingTop: "4px",
  paddingBottom: "4px",
  borderRadius: "4px",

  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
});

export const InfoDescription = styled("span")({
  fontFamily: "Manrope",
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: 0.25,
  color: colors.gray700,
});

export const InfoBox = styled(Box)({
  marginTop: 20,
  padding: 12,
  borderRadius: 8,
  border: `1px solid ${colors.gray200}`,
});
